import { Serializable } from '@/models/core/serializable';

export class Survey implements Serializable<Survey> {
  ID: number;
  type: number; // 受検コース名
  startDate: Date = new Date(); // イベント開始日
  endDate: Date = new Date(); // イベント終了日

  deserialize(input: any): Survey {
    this.ID = input.ID;
    this.type = input.Type;
    this.startDate = new Date(input.StartDate);
    this.endDate = new Date(input.EndDate);
    return this;
  }
}
